// extracted by mini-css-extract-plugin
export default {"addLinkBtn":"styles_addLinkBtn__Tb9ce","addLinkBtnIcon":"styles_addLinkBtnIcon__N8w8H","input":"styles_input__NehgL","first":"styles_first__GHxFT"};